import React from 'react';

import { embedMarketingTrackingIntoURL } from '@lendi-jam/jam-link';
import GenericOffsetCalculator from '@lendi-jam/offset-calculator';
import parse from 'html-react-parser';

import { GenericOffsetCalculatorContent } from '#contentTypes/GenericOffsetCalculator';

interface PrismicGenericOffsetCalculatorProps {
  component: GenericOffsetCalculatorContent;
}

const PrismicGenericOffsetCalculator: React.FC<PrismicGenericOffsetCalculatorProps> = ({ component: { primary } }) => (
  <GenericOffsetCalculator
    buttonLink={embedMarketingTrackingIntoURL(primary.button_link?.url)}
    buttonText={primary.button_text?.text}
    calculatorHeading={primary.calculator_heading?.text}
    contributionsTooltipContent={
      primary.contributions_tooltip_content?.html ? parse(primary.contributions_tooltip_content?.html) : undefined
    }
    disclaimer={primary.disclaimer?.text}
    graphHeading={primary.graph_heading?.text}
    offsetDelayTooltipContent={
      primary.offset_delay_tooltip_content?.html ? parse(primary.offset_delay_tooltip_content?.html) : undefined
    }
    resultBody={primary.result_body?.text}
    resultHeading={primary.result_heading?.text}
    showGraph={primary.show_graph}
  />
);

export default PrismicGenericOffsetCalculator;
